const MAX_LOGO_BYTES = 20 * 1024 * 1024;

const ALLOWED_LOGO_TYPES = new Set(['image/jpeg', 'image/png', 'image/gif']);

export const COMPANY_LOGO_ACCEPT = 'image/jpeg,image/jpg,image/png,image/gif';

export type CompanyLogoValidationResult =
  | { valid: true }
  | { valid: false; message: string };

export const validateCompanyLogoFile = (file: File): CompanyLogoValidationResult => {
  if (!ALLOWED_LOGO_TYPES.has(file.type)) {
    return {
      valid: false,
      message: 'Logo must be JPEG, PNG, or GIF.',
    };
  }

  if (file.size > MAX_LOGO_BYTES) {
    return {
      valid: false,
      message: 'Logo must be 20 MB or smaller.',
    };
  }

  return { valid: true };
};
